import {
  GroupAutomationPreferenceEnum,
  RuleGroupRequest,
  RuleGroupResponse,
  GroupMembershipTypeEnum,
  SortOrder,
} from '@electricjs/core_entity-client';
import { Application } from '@/types/applications';
import { PaginationParams } from '@/types/common';

type GroupManagementArgs = {
  organizationId: string;
  groupId: string;
};

export type hrisGroupIntegration = {
  sourceId: string;
  hrisIntegrationId: string;
};

export const GroupAutomationPreference = GroupAutomationPreferenceEnum;
export type GroupAutomationPreference = GroupAutomationPreferenceEnum;

export const GroupMembershipType = GroupMembershipTypeEnum;
export type GroupMembershipType = GroupMembershipTypeEnum;

export type Group = {
  id: string;
  name: string;
  nameFrCa?: string | null;
  createdAt: string;
  updatedAt: string;
  parentGroupId: string;
  importEnabled: boolean;
  hrisGroupIntegration?: hrisGroupIntegration;
  applicationsCount: number;
  employeesCount: number;
  joinAutomationPreference: GroupAutomationPreference | null;
  leaveAutomationPreference: GroupAutomationPreference | null;
  membershipType: GroupMembershipType;
  ruleGroups?: RuleGroupResponse[];
};

export type RenameGroupArgs = {
  newName: string;
} & GroupManagementArgs;

export type UpdateGroupArgs = {
  name: string;
  parentGroupId?: string | null;
  ruleGroups?: RuleGroupRequest[];
} & GroupManagementArgs;

export type UpdateGroupImportEnabledArgs = {
  groupName: string;
  importEnabled: boolean;
} & GroupManagementArgs;

export type UpdateGroupAutomationSettingsArgs = {
  groupName: string;
  joinAutomationPreference: GroupAutomationPreference;
  leaveAutomationPreference: GroupAutomationPreference;
} & GroupManagementArgs;

export type RemoveEmployeeFromGroupArgs = {
  employeeId: string;
} & GroupManagementArgs;

export type AddEmployeesToGroupArgs = {
  employeeIds: string[];
} & GroupManagementArgs;

export type TriggerGroupChangeReviewArgs = {
  employeeId: string;
  organizationId: string;
  groupsAdded: string[];
  groupsRemoved: string[];
  assigneeUserId: string;
};

export type TriggerDemoGroupChangeReviewArgs = TriggerGroupChangeReviewArgs & {
  hrisProviderSlug: string;
};

export type GroupApplicationManagementArgs = {
  applicationKey: string;
} & GroupManagementArgs;

export type GetApplicationGroupsArgs = {
  organizationId: string;
  applicationKey: string;
};

// Extend with additional properties as needed rather than updating `GroupManagementArgs`
export type GetGroupApplicationsArgs = GroupManagementArgs;

export type GetOrganizationGroupsArgs = {
  organizationId: string;
  orderBy?: string;
  sortOrder?: SortOrder;
  searchTerm?: string;
} & PaginationParams;

export type GetGroupsForEmployeeArgs = {
  employeeId: string;
  organizationId: string;
};

export type PreviewGroupRuleMatchesArgs = {
  organizationId: string;
  ruleGroups: RuleGroupRequest[];
  parentGroupId?: string;
  limit?: number;
  offset?: number;
};

export type AppAndGroups = {
  application: Application;
  groups: Group[];
};

export type GroupWithChildren = Group & {
  children: Group[];
};

export const GroupActionType = {
  AddApplications: 'addApplications',
  RemoveApplications: 'removeApplications',
  AddEmployees: 'addEmployees',
  RemoveEmployees: 'removeEmployees',
} as const;

export type GroupActionTypeValue =
  (typeof GroupActionType)[keyof typeof GroupActionType];

export type AddOrRemoveEmployeesActionTypes =
  | typeof GroupActionType.AddEmployees
  | typeof GroupActionType.RemoveEmployees;
